<a [attr.href]="to ? to : null" [target]="template === 'external' ? '_blank' : '_self'">
  <div class="small-card -card-container" [ngClass]="mode === 'potrait' ? '-mode-potrait' : '-mode-landscape'">
    <div class="small-card -image-container">      
      <img [src]="image" />      
    </div>
    <div class="small-card -card-details">
      @if (tag) {
        <content-tag [label]="tag"></content-tag>
      }
      <ng-content></ng-content>
    </div>
  </div>
</a>
